export default class ContactsFn {
  constructor() {
    this.initMap()
  }

  initMap = () => {
    console.log(liSiteUrl + "assets/img/icons/gmarker-2.svg");
    const locations = [
      ['Aeroporto do Pico', 38.55288172538167, -28.443670036042217, 1, liSiteUrl + "/assets/img/icons/gmarker-2.svg"],
      ['Gare Marítima de São Roque do Pico', 38.531613483506256, -28.32121970424749, 2, liSiteUrl + "/assets/img/icons/gmarker-2.svg"],
      ['Gare Marítima da Madalena do Pico', 38.53579326831203, -28.529602716764053, 3, liSiteUrl + "/assets/img/icons/gmarker-2.svg"],
      ['<a target="_blank" href="https://goo.gl/maps/9JEH2xEKSwmrtpg4A">PocinhoBay</a>', 38.49571005285734, -28.5389364789787, 4, liSiteUrl + "/assets/img/icons/gmarker-4.svg"]
    ];

    const map = new google.maps.Map(document.getElementById("map"), {
      zoom: 11,
      center: new google.maps.LatLng(38.495271, -28.538893),
      styles: [
        {
          "featureType": "administrative",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#444444"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [
            {
              "color": "#f6f4f4"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "all",
          "stylers": [
            {
              "saturation": -100
            },
            {
              "lightness": 45
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "simplified"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "all",
          "stylers": [
            {
              "color": "#dbd6d3"
            },
            {
              "visibility": "on"
            }
          ]
        }
      ]
    });

    var infowindow = new google.maps.InfoWindow();
    var marker, i;
    for (i = 0; i < locations.length; i++) {
      marker = new google.maps.Marker({
        position: new google.maps.LatLng(locations[i][1], locations[i][2]),
        icon: locations[i][4],
        map: map
      });
      google.maps.event.addListener(marker, 'click', (function (marker, i) {
        return function () {
          infowindow.setContent(locations[i][0]);
          infowindow.open(map, marker);
        }
      })(marker, i));
    }
  }

}
